import React from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import Button from '@material-ui/core/Button';
import { isMobile, isTablet } from "react-device-detect";
import { decode as htmlDecode } from 'html-entities';

import { useAuth } from '../../../../../../core/contexts/AuthContext';
import { IGeoBound } from '../../../../../../core/store/GeoBoundaryStore';

interface IProps {
  pageSizeChanged: any;
  pageNoChanged: any;
  sortFieldChanged: any;
  sortField: string;
  sortOrder: number;
  addTab: any;
  items: any;
  deleteGeoBound: any;
}

const GeoBoundaryListItem = (props: IProps) => {

  const { pageSizeChanged, pageNoChanged, sortFieldChanged, sortField, addTab, deleteGeoBound } = props;
  const items = props.items.Data;
  const paging = props.items.Paging;

  const { chkRolePermissions } = useAuth();

  // The delete cell is gated on this permission, granted by AuthContext's async
  // /identity/rolepermission fetch. When the grant lands AFTER the table has first rendered,
  // primereact's row memoization keeps the (already-rendered) cell stale, so the action never
  // appears. Key the table on the grant so it remounts once when the permission resolves.
  const canDeleteGeoBound = chkRolePermissions("Manage", "Geo Bounds", "Edit");

  const onPage = (event: any) => {

    const { page, rows } = event;
    if (Number(paging.PageSize) !== rows) {
      pageSizeChanged(rows);
    }
    else if (Number(paging.PageSize) !== page + 1) {
      pageNoChanged(page + 1);
    }
  };


  const setDeleteContents = (row: IGeoBound) => {

    if (!chkRolePermissions("Manage", "Geo Bounds", "Edit")) {
      return "";
    }

    return (
      <span onClick={() => deleteGeoBound(row)} >
        <Button variant={isMobile ? "outlined" : "text"} color="secondary" style={{ textTransform: 'none' }} >X</Button>
      </span>
    );
  };

  const setDetail = (row: IGeoBound, val: string) => {
    return (
      <span className="info-sub-head cursor-pointer" onClick={() => addTab(row)} >
        <strong className="opt-l-number">
          {val}
        </strong>
      </span>
    );
  };

  const setResponsiveContents = (title: string, contents: any, isTitle: boolean = true) => {
    return (
      <>
        {isTitle && <span className="p-column-title">{title}</span>}
        <span className="p-column-content">{contents}</span>
      </>
    );
  };

  const setNormalDataTable = () => {
    return (
      <DataTable
        key={`geobound-${canDeleteGeoBound}`}
        rowHover
        style={{ position: "relative" }}
        //size="small"
        value={items}
        className="p-datatable-gridlines  p-datatable-gridlines-custom p-datatable-sm p-datatable-striped p-datatable-striped-custom"
        resizableColumns columnResizeMode="fit"
        paginator
        paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
        currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
        rows={Number(paging.PageSize)}
        rowsPerPageOptions={[10, 20, 50, 100, 500]}
        totalRecords={Number(paging.TotalNumberOfRecords)}
        lazy onPage={onPage} first={Number(paging.PageSize) * (Number(paging.PageNumber) - 1)}
        scrollable scrollHeight="calc(100vh - 390px)"
        onSort={(e) => sortFieldChanged(e)}
        sortField={sortField}
      >
        <Column sortable field="GeoBoundaryName" header="GeoBoundary Name" body={(r: IGeoBound) => setDetail(r, htmlDecode(r.GeoBoundaryName))} style={{ width: '350px' }} />
        <Column sortable field="Address" header="Address" body={(r: IGeoBound) => setDetail(r, htmlDecode(r.Address))} />
        <Column field="" header="" body={(r: IGeoBound) => setDeleteContents(r)} style={{ width: '5%' }} />

      </DataTable>
    );
  };


  const setResponsiveDataTable = () => {
    return (
      <DataTable
        key={`geobound-responsive-${canDeleteGeoBound}`}
        header='Users'
        style={{ position: "relative" }}
        value={items}
        className="p-datatable-responsive p-datatable-sm "
        paginator
        paginatorTemplate="CurrentPageReport  PageLinks  RowsPerPageDropdown"
        currentPageReportTemplate=" {first} to {last} of {totalRecords}"
        rows={Number(paging.PageSize)}
        rowsPerPageOptions={[10, 20, 50, 100, 500]}
        totalRecords={Number(paging.TotalNumberOfRecords)}
        lazy onPage={onPage} first={Number(paging.PageSize) * (Number(paging.PageNumber) - 1)}
      >
        <Column header="Name" body={(r: IGeoBound) => setResponsiveContents('Name', setDetail(r, htmlDecode(r.GeoBoundaryName)))} />
        <Column header="Address" body={(r: IGeoBound) => setResponsiveContents('Address', htmlDecode(r.Address))} />
        <Column header="" body={(r: IGeoBound) => setDeleteContents(r)} />
      </DataTable>
    );
  };

  const setDataTable = () => {
    if (isMobile && !isTablet) {
      return setResponsiveDataTable();
    }
    else {
      return setNormalDataTable();
    }
  };

  return (
    <>
      <div
        className="perfect-scrollbar"
        style={{ position: "relative", width: "100%", height: "100%" }}
      >
        {setDataTable()}
      </div>

    </>
  );
};

export default GeoBoundaryListItem;
